<template>
    <!-- ------------------------------------- 隐私保护政策 ----------------------------------- -->
    <div class="blog">
        <!-- ---------------------------------- 顶部导航栏 ---------------------------------- -->
        <Header></Header>
        <!-- ---------------------------------- 海报图 ---------------------------------- -->
        <!-- ---------------------------------- 文章 ---------------------------------- -->
        <div class="article">
            <!-- 主文章 -->
            <div class="article_main">
                <!-- 文章标题 -->
                <h2 class="article_title">隐私保护政策</h2>
                <!-- 文章信息 -->
                <div class="article_information">
                    <h3 class="title">1. 个人资料（隐私）条例</h3>
                    <p>
                        1.1
                        Renaud蔚诺（「我们」或「本公司」）在收集、保存、使用及传送个人资料时，尊重法例赋予阁下的隐私权利；而本「收集个人资料声明」旨在说明我们处理个人隐私的方法。本公司会确保我们的员工在处理个人资料时依从最严格的保安及保密标准。
                    </p>
                    <p>
                        1.2
                        以下将详细说明我们处理个人资料的政策及方法，请仔细参阅及理解。文中所述的政策适用于蔚诺网页（下称「本网页」）的所有使用者。本公司有权按需要随时修订、或另行更改有关的内容。
                    </p>
                    <p>
                        1.3
                        倘若本声明的英文本与中文本有任何差异，则以中文本为准。
                    </p>
                    <p>
                        1.4
                        「个人资料」指任何阁下在「订阅我们」或「联络我们」的表格上向我们提供的个人资料（包括但不限于阁下的姓名、电邮地址、电话号码、性别）。
                    </p>

                    <h3 class="title">2. 个人资料的收集及用途</h3>
                    <p>
                        2.1
                        当阁下填写在「订阅我们」或「联络我们」表格（下称「该表格」）时，我们将收集阁下的个人资料。
                    </p>
                    <p>
                        2.2
                        倘若阁下为13岁以下，在提供任何个人资料前，必须先征求家长或监护人同意。
                    </p>
                    <p>
                        2.3
                        阁下向我们提供的个人资料将会被Renaud蔚诺用于以下目的（下称「该目的」）：
                    </p>
                    <p>
                        a.申请、日常运作、延续使用及终止Renaud蔚诺电子通讯的订阅；
                    </p>
                    <p>b. 向阁下提供Renaud蔚诺的信息、通告及其他信息；</p>
                    <p>c. 处理及跟进服务通话、查询及投诉；</p>
                    <p>d. 核实阁下的身份；及</p>
                    <p>
                        e.
                        按照任何对于蔚诺具有约束力的法例要求，而向任何政府机关披露个人资料。
                    </p>
                    <p>
                        2.4
                        阁下可自愿决定是否提供表格上没有被标示为必须填写的个人资料。
                    </p>
                    <p>
                        2.5 使用数据作市场推广（Direct Marketing）
                        当阁下申请「订阅我们」后，我们会使用阁下的个人资料作市场推广；我们将会使用阁下的姓氏、名字及电邮地址推广。
                    </p>

                    <h3 class="title">3.保留、储存及披露个人资料</h3>
                    <p>3.1 我们在收集阁下的个人资料时，将会：</p>
                    <p>
                        a.
                        向阁下说明我们正在收集你的个人资料以及收集的用途（以本「收集个人资料声明」或独立通知）；
                    </p>
                    <p>b. 给予阁下反对使用个人资料作特定用途的机会；及</p>
                    <p>
                        c.
                        说明我们如何储存及处理个人资料的方法，以及可供阁下查阅、更改及删除已储存个人资料的方法。
                    </p>
                    <p>
                        3.2
                        我们将采取所有切实可行的措施，将阁下的个人资料保密，然而我们可以向以下人士转移/分派这些数据用于该目的：
                    </p>
                    <p>
                        a.
                        若Renaud蔚诺决定出售其业务的任何相关部份，Renaud蔚诺对阁下个人资料权利的任何实际或建议售让人、承转人或继承人；
                    </p>
                    <p>
                        b.
                        向Renaud蔚诺提供行政、电讯、电脑及其他服务的任何代理人、承办商或第三者服务供应商；及
                    </p>
                    <p>
                        c.
                        为遵守任何对于Renaud蔚诺具有约束力的法例要求，或为了符合由监管或其他机构发出的任何指引或工作守则，而Renaud蔚诺有义务向其披露数据的人士或机构。
                    </p>

                    <h3 class="title">4. 保安</h3>
                    <p>
                        除以上 &lt;
                        3保留、储存及披露个人资料>所述外，阁下的个人资料不论以任何方式储存，将只限于已获本公司授权的雇员或承办商查阅。凡以电子方式储存的个人资料，将会储存于严密监管的服务器内，并加有密码保护（或使用其他同等形式的保障措施），同时亦只限于获得Renaud蔚诺授权的人员或承办商查阅。获授权的雇员及承办商，只可在按照本收集个人资料声明的规定下处理相关个人资料。
                    </p>
                    <h3 class="title">5.查阅及更正个人资料</h3>
                    <p>
                        如阁下欲查阅或要求更正本公司持有阁下的个人资料，请电邮至
                        support@renaudchina.com。本公司会在收到阁下的指示后7个工作天内给予回复及更新本公司之纪录。
                    </p>

                    <h3 class="title">6. 停止使用个人资料作直销用途</h3>
                    <p>
                        若阁下不想收取本公司任何推广或宣传数据，不论阁下是否较早前已给予本公司同意（书面或口头）向阁下发放该等数据，阁下可随时电邮至
                        support@renaudchina.com表示要求本公司停止使用阁下的个人资料。本公司会在收到指示后7个工作天内将阁下的个人资料从本公司之名单中删除，并停止使用阁下的个人资料作直接促销用途。
                    </p>
                    <h3 class="title">7. 数据的保留</h3>
                    <p>
                        我们将按收集数据目的所需的时间保留阁下的个人资料。无需保留的个人资料将会销毁。
                    </p>

                    <h3 class="title">
                        8. 此收集个人资料声明可作修订。任何修改将于本网页公布。
                    </h3>
                    <p></p>
                </div>
            </div>
            <!-- 副文章 -->
        </div>
        <!-- ---------------------------------- 分页栏 ---------------------------------- -->
        <!-- <div class="paging">
            <el-pagination
                    background
                    layout=" pager, next"
                    :total="50">
            </el-pagination>
        </div> -->
        <!-- ---------------------------------- 底部栏 ---------------------------------- -->
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/Header';
import Footer from '@/components/Footer';
export default {
    components: {
        Header,
        Footer,
    },
    methods: {
        // 跳转文章详情
        toBlogDetails() {
            this.$router.push({
                path: '/blogDetails',
            });
        },
    },
};
</script>

<style lang="less" scoped>
// ---------------------------- 细则 ---------------------------------
// ------------- mobile端样式 -------------
@media only screen and (max-width: 960px) {
    // 屏幕小于960px
    .article {
        // 主文章
        .article_main {
            width: 85%;
            // 文章标题
            .article_title {
                font-size: 64px;
                margin-bottom: 20px;
            }
            // 文章信息
            .article_information {
                .title {
                    font-size: 59px;
                    margin: 30px 0 20px 0;
                }
                p {
                    font-size: 54px;
                    margin-bottom: 20px;
                }
            }
        }
    }
}
// ------------- pc端样式 -------------
@media only screen and (min-width: 960px) {
    // 屏幕大于960px
    .article {
        // 主文章
        .article_main {
            width: 55%;
            // 文章标题
            .article_title {
                font-size: 38px;
                margin: 0;
            }
            // 文章信息
            .article_information {
                .title {
                    font-size: 19px;
                    margin: 0;
                    margin-top: 10px;
                }
                p {
                    font-size: 16px;
                    margin: 0;
                }
            }
        }
    }
}

.article {
    width: 100%;
    margin: 0 auto;
    padding: 80px 0 60px 0;
    display: flex;
    justify-content: space-between;
    font-family: '等线';
    // 主文章
    .article_main {
        margin: 0 auto;
        // 文章标题
        .article_title {
            font-weight: 600;
            color: #192c54;
            letter-spacing: 2px;
            cursor: pointer;
        }
        // 文章信息
        .article_information {
            font-family: Microsoft YaHei;
            width: 100%;
            .title {
                font-family: Microsoft YaHei;
                font-weight: bold;
            }
            p {
                font-family: Microsoft YaHei;
                color: #000;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/privacy.vue